var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "hb-icon-button",
      class: "hb-icon-button--" + _vm.tone,
      attrs: {
        type: "button",
        "aria-label": _vm.label,
        title: _vm.label,
        disabled: _vm.disabled,
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [_c("feather-icon", { attrs: { icon: _vm.icon, size: "17" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }